module.exports = __webpack_public_path__ + "img/edit.38cd11ee.svg";